import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  createCampaignAsset,
  deactivateCampaignAsset,
  getCampaignAssets,
  updateCampaignAsset,
  type CampaignAssetInput,
} from '../api/campaignAssets';

/** `enabled` so the Sales tab only fetches when it is the one on screen. */
export function useCampaignAssets(enabled = true) {
  return useQuery({
    queryKey: ['campaign-assets'],
    queryFn: getCampaignAssets,
    enabled,
  });
}

function useInvalidate() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['campaign-assets'] });
}

export function useCreateCampaignAsset() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (input: CampaignAssetInput) => createCampaignAsset(input),
    onSuccess: invalidate,
  });
}

export function useUpdateCampaignAsset() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: ({ id, ...input }: Partial<CampaignAssetInput> & { id: string; active?: boolean }) =>
      updateCampaignAsset(id, input),
    onSuccess: invalidate,
  });
}

export function useDeactivateCampaignAsset() {
  const invalidate = useInvalidate();
  return useMutation({
    mutationFn: (id: string) => deactivateCampaignAsset(id),
    onSuccess: invalidate,
  });
}
